import {Directive, ElementRef, HostListener} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numberLettersOnly]'
})

export class NumberLettersOnlyDirective {
  // allow integer values only
  private regex: RegExp = new RegExp(/^[A-Za-z0-9_-]*$/g);
  // allow key codes for special events
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];


  constructor(private el: ElementRef,private control: NgControl) {
  }

  // @HostListener('keydown', ['$event'])
  // onkeydown(event: KeyboardEvent) {
  //   // allow backspace, tab, end and home keys
  //   if (this.specialKeys.indexOf(event.key) !== -1) {
  //     return;
  //   }
  //
  //   const current: string = this.el.nativeElement.value;
  //   const next: string = current.concat(event.key);
  //   if (next && !String(next).match(this.regex)) {
  //     event.preventDefault();
  //   }
  // }

  // @HostListener('paste', ['$event'])
  // onPaste(event: ClipboardEvent) {
  //
  //   let text = event.clipboardData.getData('Text');
  //
  //   if (!this.regex.test(text)) {
  //
  //     event.preventDefault();
  //
  //     text = text.replace(/[^A-Za-z0-9_-]/g,"");
  //
  //     const current: string = this.el.nativeElement.value;
  //
  //     this.el.nativeElement.value =current.concat(text);
  //
  //   }
  // }

  @HostListener('ngModelChange', ['$event'])
  ngModelChange(value: any) {
    value = value.replace(/[^A-Za-z0-9_-]/g,"");
    this.control.valueAccessor?.writeValue(value);
  }
}
